import { createContext } from "react";

export const MyUserContext = createContext();
export const MyCartContext = createContext();